<div *ngIf="selectedChannel">
  <div class="header-container-outer" *ngIf="showMobileHeader" #headerMobile>
    <div class="header-container" [ngClass]="{ 'sticky': isSticky }">
      <div class="orderType-location-container">
        <div (click)="onClickOrderTypeLocation()">
          <div class="orderType-container">
            <i [ngClass]="orderTypeicon"></i>
            <h1>{{orderTypeDesc | translate}}</h1>
          </div>
          <h1 class="location-heading truncateText" *ngIf="orderType !== orderTypeFlag.DineIn || !shareTable">
            {{fulladdress
            ? fulladdress : 'hint.search.address' | translate}}</h1>
          <h1 *ngIf="orderType == orderTypeFlag.DineIn && shareTable && tblNoLbl">{{staticTableNo ? tblNoLbl + ' ' +
            staticTableNo : ('location.scan.desc' | translate)}}</h1>
          <h1 *ngIf="orderType == orderTypeFlag.DineIn && shareTable && !tblNoLbl">{{staticTableNo ?
            ("merchant.qr.dinein.table.no" | translate : { tableNo: staticTableNo }) : ('location.scan.desc' |
            translate)}}
          </h1>

        </div>
        <app-tooltip *ngIf="showLocationTooltipForOrderType && !hasSelectedAddress && (showLocationTooltip$ | async)"
          [content]="locationTooltip"></app-tooltip>
      </div>

      <div class="channelIcon-container">
        <i class="icon-channel" *ngIf="(selectedChannel && !selectedChannel.imageLink) || !selectedChannel"></i>
        <img src={{selectedChannel.imageLink}} alt="channel logo" loading="lazy"
          *ngIf="selectedChannel && selectedChannel.imageLink">
      </div>
    </div>
  </div>
</div>
